import React from "react";
import { Box, Typography } from "@mui/material";

const FAQ = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h4" sx={{ mb: 2 }}>Frequently Asked Questions</Typography>
    <Typography>Find answers to common questions about the platform here.</Typography>
  </Box>
);

export default FAQ;
